import { Navigate } from "./../../../../../router-utils"

export default function RedirectToLoginPage() {
	return <Navigate to={"/login"} replace />
}
